export const payableCurrencySymbols = {
  GBP: '£',
  USD: '$',
  EUR: '€',
}
